import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { A_WEEK_IN_DAYS, A_MONTH_IN_DAYS } from '../../constants';

const TrialDurationString = ({ duration }) => {
  if (duration < A_MONTH_IN_DAYS) {
    const weeks = Math.max(1, Math.floor(duration / A_WEEK_IN_DAYS));
    return (
      <FormattedMessage
        id="conversion-form.info.duration.weeks"
        defaultMessage="{count, plural, =1 {One week} =2 {Two weeks} =3 {Three weeks} =4 {Four weeks} other {# weeks}}"
        values={{ count: weeks }}
      />
    );
  }

  const months = Math.floor(duration / A_MONTH_IN_DAYS);
  return (
    <FormattedMessage
      id="conversion-form.info.duration.months"
      defaultMessage="{count, plural, =1 {One month} =2 {Two months} =3 {Three months} =4 {Four months} =5 {Five months} =6 {Six months} =7 {Seven months} =8 {Eight months} =9 {Nine months} =10 {Ten months} =11 {Eleven months} =12 {Twelve months} other {# months}}"
      values={{ count: months }}
    />
  );
};

TrialDurationString.propTypes = {
  duration: PropTypes.number.isRequired,
};

export default TrialDurationString;
